import callApiAxiosClient from '../../axios/axios_client';

type AddTechnicalIncidentLogArgs = {
  incident_id: number;
  message: string;
};

async function addTechnicalIncidentLog({ incident_id, message }: AddTechnicalIncidentLogArgs): Promise<void> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;

  return callApiAxiosClient<void>({
    method: 'post',
    url: 'technicalincidents/logs',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: {
      incident_id,
      message,
    },
  });
}

export default addTechnicalIncidentLog;
